import api from '@/libs/api'

export default {
  namespaced: true,
  state: {
    profileInformation: null,
    fetchingProfileInformation: false,
    savingProfileInformation: false,
    savingProfilePicture: false,
  },
  mutations: {
    SET_PROFILE_INFORMATION(state, permissions) {
      state.profileInformation = permissions
    },
    SET_FETCHING_PROFILE_INFORMATION(state, value) {
      state.fetchingProfileInformation = value
    },
    SET_SAVING_PROFILE_INFORMATION(state, value) {
      state.savingProfileInformation = value
    },
    SET_SAVING_PROFILE_PICTURE(state, value) {
      state.savingProfilePicture = value
    },
  },
  actions: {
    fetchProfileInformation({ commit }) {
      commit('SET_FETCHING_PROFILE_INFORMATION', true)
      return new Promise((resolve, reject) => {
        api('porta')
          .get('/ManageApi/UserProfile')
          .then(response => {
            commit('SET_PROFILE_INFORMATION', response.data)
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_FETCHING_PROFILE_INFORMATION', false)
          })
      })
    },
    saveProfileInformation({ commit }, profileData) {
      commit('SET_SAVING_PROFILE_INFORMATION', true)
      return new Promise((resolve, reject) => {
        api('porta')
          .put('/ManageApi/UpdateUserProfile', profileData)
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            reject(error)
          })
          .finally(() => {
            commit('SET_SAVING_PROFILE_INFORMATION', false)
          })
      })
    },
    saveProfilePicture({ commit }, file) {
      commit('SET_SAVING_PROFILE_PICTURE', true)
      return new Promise((resolve, reject) => {
        if (file) {
          const toUpload = new FormData()
          toUpload.append('file', file)
          api('porta')
            .post('/ManageApi/UploadProfilePicture', toUpload, {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'multipart/form-data',
            })
            .then(response => {
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
            .finally(() => {
              commit('SET_SAVING_PROFILE_PICTURE', false)
            })
        } else {
          api('porta')
            .delete('/ManageApi/RemoveProfilePicture')
            .then(response => {
              resolve(response)
            })
            .catch(error => {
              reject(error)
            })
            .finally(() => {
              commit('SET_SAVING_PROFILE_PICTURE', false)
            })
        }
      })
    },
  },
}
